import React, { FC, memo, useMemo } from 'react';
import { ScrollView, ScrollViewProps, StyleSheet } from 'react-native';

const StretchedScrollView: FC<ScrollViewProps> = (props) => {
  const stretchedScrollViewStyles = useMemo(() => {
    return StyleSheet.create({
      container: {
        flexGrow: 1
      },
      // TODO: Remove height: 100 when newArchEnabled is enabled (RN 0.77+ fix for modal with scrollview)
      // See: https://github.com/facebook/react-native/issues/48822#issuecomment-2667011212
      content: {
        height: 100
      }
    });
  }, []);

  const mergedStyle = StyleSheet.flatten([stretchedScrollViewStyles.content, props.style]);

  return <ScrollView {...props} contentContainerStyle={stretchedScrollViewStyles.container} style={mergedStyle} />;
};

export default memo(StretchedScrollView);
